import { render, staticRenderFns } from "./todoItem.vue?vue&type=template&id=27a2eb74&scoped=true&"
import script from "./todoItem.vue?vue&type=script&lang=js&"
export * from "./todoItem.vue?vue&type=script&lang=js&"
import style0 from "./todoItem.vue?vue&type=style&index=0&id=27a2eb74&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2eb74",
  null
  
)

export default component.exports